"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceableEndpoint = void 0;
var ReplaceableEndpoint_1 = require("./ReplaceableEndpoint");
Object.defineProperty(exports, "ReplaceableEndpoint", { enumerable: true, get: function () { return ReplaceableEndpoint_1.ReplaceableEndpoint; } });
//# sourceMappingURL=index.js.map